const MOBILE_FILTERS_BODY_CLASS = 'mobile-filters-open';

const mobileFilters = {
  data() {
    return {
      mobileFiltersOpen: false,
      mobileFiltersBodyLocked: false,
      mobileFiltersScrollTop: 0,
      mobileFiltersPreviousBodyStyles: {},
    };
  },
  methods: {
    isMobileFiltersViewport() {
      return typeof window !== 'undefined' && window.matchMedia('(max-width: 991px)').matches;
    },
    lockMobileFiltersBodyScroll() {
      if (!this.isMobileFiltersViewport() || this.mobileFiltersBodyLocked) {
        return;
      }

      const { body } = document;

      this.mobileFiltersScrollTop = window.scrollY || window.pageYOffset || 0;
      this.mobileFiltersPreviousBodyStyles = {
        overflow: body.style.overflow,
        position: body.style.position,
        top: body.style.top,
        width: body.style.width,
      };

      body.classList.add(MOBILE_FILTERS_BODY_CLASS);
      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = `-${this.mobileFiltersScrollTop}px`;
      body.style.width = '100%';

      this.mobileFiltersBodyLocked = true;
    },
    unlockMobileFiltersBodyScroll() {
      if (!this.mobileFiltersBodyLocked) {
        return;
      }

      const { body } = document;
      const previousStyles = this.mobileFiltersPreviousBodyStyles;
      const scrollTop = this.mobileFiltersScrollTop;

      body.classList.remove(MOBILE_FILTERS_BODY_CLASS);
      body.style.overflow = previousStyles.overflow || '';
      body.style.position = previousStyles.position || '';
      body.style.top = previousStyles.top || '';
      body.style.width = previousStyles.width || '';

      this.mobileFiltersBodyLocked = false;
      this.mobileFiltersScrollTop = 0;
      this.mobileFiltersPreviousBodyStyles = {};

      window.scrollTo(0, scrollTop);
    },
    openMobileFilters() {
      this.mobileFiltersOpen = true;
    },
    closeMobileFilters() {
      this.mobileFiltersOpen = false;
    },
    toggleMobileFilters() {
      this.mobileFiltersOpen = !this.mobileFiltersOpen;
    },
  },
  beforeDestroy() {
    this.unlockMobileFiltersBodyScroll();
  },
  watch: {
    mobileFiltersOpen(isOpen) {
      if (isOpen) {
        this.lockMobileFiltersBodyScroll();
        return;
      }

      this.unlockMobileFiltersBodyScroll();
    },
    '$route.path': function onRouteChange() {
      this.closeMobileFilters();
    },
  },
};

export default mobileFilters;
